// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 加载 element ui
import Element from 'element-ui'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
//加载全局scss 以及 lodash
import './assets/styles/index.scss' // global css
import _ from 'lodash';
//加载mint ui
import 'mint-ui/lib/style.css'

Vue.prototype._ = _;
Vue.use(Element, {
  zhLocale
})

Vue.config.productionTip = false

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js